// extracted by mini-css-extract-plugin
export default {"content":"za9WcjwJ8KaJP6CHk0uC","revoke-token":"NM0XxyKsYpFcJukSI9yC"};